<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes('w-6 h-6 ', additionalClass)}
>
	<path
		d="M16.5 4.28571C16.5 4.10439 16.5834 3.91163 16.7647 3.75621C16.9484 3.59874 17.212 3.5 17.5 3.5H20.5C20.788 3.5 21.0516 3.59874 21.2353 3.75621C21.4166 3.91163 21.5 4.10439 21.5 4.28571V19.7143C21.5 19.8956 21.4166 20.0884 21.2353 20.2438C21.0516 20.4013 20.788 20.5 20.5 20.5H17.5C17.212 20.5 16.9484 20.4013 16.7647 20.2438C16.5834 20.0884 16.5 19.8956 16.5 19.7143V4.28571Z"
		stroke="currentColor"
	/>
	<path
		d="M9.5 8.27273C9.5 8.06491 9.58117 7.86738 9.72284 7.72313C9.86422 7.57918 10.054 7.5 10.25 7.5H12.75C12.946 7.5 13.1358 7.57918 13.2772 7.72313C13.4188 7.86738 13.5 8.06491 13.5 8.27273V19.7273C13.5 19.9351 13.4188 20.1326 13.2772 20.2769C13.1358 20.4208 12.946 20.5 12.75 20.5H10.25C10.054 20.5 9.86421 20.4208 9.72284 20.2769C9.58117 20.1326 9.5 19.9351 9.5 19.7273V8.27273Z"
		fill="currentColor"
		stroke="currentColor"
	/>
	<path
		d="M2.5 13.2857C2.5 13.0729 2.58234 12.8715 2.72461 12.7251C2.86642 12.5793 3.05571 12.5 3.25 12.5H5.75C5.94429 12.5 6.13358 12.5793 6.27539 12.7251C6.41766 12.8715 6.5 13.0729 6.5 13.2857V19.7143C6.5 19.9271 6.41766 20.1285 6.27539 20.2749C6.13358 20.4207 5.9443 20.5 5.75 20.5H3.25C3.0557 20.5 2.86642 20.4207 2.72461 20.2749C2.58234 20.1285 2.5 19.9271 2.5 19.7143V13.2857Z"
		fill="currentColor"
		stroke="currentColor"
	/>
</svg>
